import { Component } from '@angular/core';
import {Platform, NavController, ModalController, AlertController, PopoverController, NavParams} from 'ionic-angular';

import { LoadingPage } from '../loading/loading';
import { EditInfoPage } from '../edit-info/edit-info';
import { ConsultationPage } from '../consultation/consultation';
import { DispensaryPage } from '../dispensary/dispensary';
// import { VerificationPage } from '../verification/verification';
//
import { PopoverQueuePage } from '../popover-queue/popover-queue';
//
import { DataProvider } from '../../providers/data/data';
import { ConstantsProvider } from '../../providers/constants/constants';
import { CloudDataProvider } from '../../providers/cloud-data/cloud-data';
import { ConsultationDataProvider } from '../../providers/consultation-data/consultation-data';
import { ConsultationDataParserProvider } from '../../providers/consultation-data-parser/consultation-data-parser';
//
import { PdfViewerProvider } from '../../providers/pdf-viewer/pdf-viewer';
import { ConsultationHistoryProvider } from '../../providers/cons-history/cons-history';
import { PrescriptionProvider } from '../../providers/prescription/prescription';
import { MedicalCertProvider } from '../../providers/medical-cert/medical-cert';
import { SickLeaveProvider } from '../../providers/sick-leave/sick-leave';
import { DispLabelProvider } from '../../providers/disp-label/disp-label';

import * as $ from 'jquery';
import { HelperProvider } from '../../providers/helper/helper';
@Component({

   selector: 'page-history',
   templateUrl: 'history.html'
})

export class HistoryPage {
   private medHistory = [
      { display: '目前最痛苦症狀/主訴', name: 'mr_main' },
      { display: '發病時間及初起症狀', name: 'mr_symptom' },
      { display: '經期史', name: 'mr_menstrual_history' },
      { display: 'PMS', name: 'mr_pms' },
      { display: '經痛', name: 'mr_dysmenorrhea' },
      { display: '敏感史', name: 'mr_allergy' },
      { display: '鼻', name: 'mr_nose' },
      { display: '皮膚', name: 'mr_skin' },
      { display: '藥物', name: 'mr_medicine' },
      { display: '食物', name: 'mr_food' },
      { display: '遺傳病', name: 'mr_gen_disease' },
      { display: '慢性病史', name: 'mr_chronic' },
      { display: '糖尿', name: 'mr_diabetes' },
      { display: '膽固醇', name: 'mr_cholesterol' },
      { display: '手術史及其他', name: 'mr_others' }
   ];

   // data from server
   private consultations = [];
   private consObjs = [];
   private dispObjs = [];
   private usagesObjs = [];
   private tickets = [];
   private active = [];

   // data for UI
   private mainSymptoms = [];
   private mainRemarks = [];
   private periodSymptoms = [];
   private periodRemarks = [];
   private otherSymptoms = [];
   private otherRemarks = [];
   private bpSymptoms = [];
   private bpRemarks = [];
   private shouldShowTopRightButton = true;

   /** ----- Constructor ----- **/

   constructor(private data: DataProvider,
      private constants: ConstantsProvider,
      private cloudData: CloudDataProvider,
      private consultationData: ConsultationDataProvider,
      private consultationParser: ConsultationDataParserProvider,
      private platform: Platform,
      private navCtrl: NavController,
      private modalCtrl: ModalController,
      private alertCtrl: AlertController,
      private popoverCtrl: PopoverController,
      private pdfViewer: PdfViewerProvider,
      private dispLabel: DispLabelProvider,
      private consHistory: ConsultationHistoryProvider,
      private medicalCert: MedicalCertProvider,
      private sickLeave: SickLeaveProvider,
      private prescription: PrescriptionProvider,
      private params: NavParams,
      private helper: HelperProvider,
   ) { }


   /** ----- View LifeCycle ----- **/

   ionViewWillEnter() {
      this.shouldShowTopRightButton = this.data.isPhy ? true : false;
      // show loading indicator and try to get consultation(s) of current viewing patient
      let loading = this.modalCtrl.create(LoadingPage, {}, { enableBackdropDismiss: false });
      loading.present();

      if(this.params.get('clearData') != false){
        this.consultationData.clearAll();
      }

      const pList: Promise<any>[] = [
        this.getConsultations().then(res => {
          if (this.params.get('clearData') != false &&
            ['pending', 'done', 'active'].indexOf(this.data.selectedTicket.tkt_status) !== -1
          ) {
            this.parseConsultationData();
          }
        }),
        this.getDispList(),
      ];

      Promise.all(pList).then(() => {
       loading.dismiss()
      })

      this.getApiDate();
      // this.getDispList().then(res => {

      //    console.log(JSON.stringify(res));
      // });

      let val = this.platform.height();
      $('.history-info-scroll').each(function (i, obj) {

         $(obj).css('height', (val - 70 - 45 - 45 - 90 - 40) / 2 + 'px');
      });


      if (this.constants.selectedTicket['consultation'] != null) {

         this.consultations.push(this.constants.selectedTicket['consultation']);
         // reset consultationItems and dispensaryItems in the listonStartClicked
         this.consObjs = [];
         this.dispObjs = [];
         this.usagesObjs = [];
         for (let i = 0; i < this.consultations.length; i++) {
            // symptoms
            let symptoms = JSON.parse(this.consultations[i]['con_symptoms']);
            if (symptoms != null) {
               let dataObj = (symptoms['data'].length > 0) ? JSON.parse(symptoms['data']) : [];
               let remarkObj = (symptoms['remark'].length > 0) ? JSON.parse(symptoms['remark']) : [];
               symptoms['data'] = dataObj;
               symptoms['remark'] = remarkObj;
               this.consObjs.push(symptoms);
            }
            else {
               this.consObjs.push({});
            }

            // dispensaries
            let disps = JSON.parse(this.consultations[i]['con_dispensary']);
            this.dispObjs.push(disps);
            if (disps != null) {
               for (let j = 0; j < disps.length; j++) {
                  console.log('disp data: ' + disps[j]['data'][0]);
                  console.log('disp usage: ' + disps[j]['usage'][0]['zh']);
                  let dataObj = (disps[j]['data'].length > 0) ? disps[j]['data'] : [];
                  let usageObj = (disps[j]['usage'].length > 0) ? disps[j]['usage'] : [];
                  this.dispObjs.push(dataObj);
                  this.usagesObjs.push(usageObj);
               }
            }
            else {
               this.dispObjs.push([]);
               this.usagesObjs.push([]);
            }
         }
      }
   }


   // /** ----- Internal Methods ----- **/
   //
   getConsultations = () => {

      return new Promise(resolve => {

         // pack params and send to server
         let params = {
            'token': this.data.token,
            'pat_row_id': this.data.selectedPatient['id']
         };
         this.cloudData.getConsultationsHistory(params).then(res => {
            // handle response
            if (res['status'] == true) {
               // save result
               this.consultations = res['result']['consultations'];
               // console.log(this.consultations[-1])
               if (this.consultations.length > 0)
                  this.consultationData.consultation = this.consultations[0];
               this.tickets = res['result']['tickets'];
               this.constants.selectedMedicals = res['result']['medical_records'];
               this.constants.physicians = res['result']['physicians'];

               // reset consultationItems and dispensaryItems in the list
               this.consObjs = [];
               this.dispObjs = [];
               this.usagesObjs = [];
               for (let i = 0; i < this.consultations.length; i++) {
                  // symptoms
                  let symptoms = JSON.parse(this.consultations[i]['con_symptoms']);
                  if (symptoms != null) {
                     let dataObj = (symptoms['data'].length > 0) ? JSON.parse(symptoms['data']) : [];
                     let remarkObj = (symptoms['remark'].length > 0) ? JSON.parse(symptoms['remark']) : [];
                     symptoms['data'] = dataObj;
                     symptoms['remark'] = remarkObj;
                     this.consObjs.push(symptoms);
                  }
                  else {
                     this.consObjs.push({});
                  }

                  // dispensaries
                  let disps = JSON.parse(this.consultations[i]['con_dispensary']);
                  this.dispObjs.push(disps);
                  if (disps != null) {
                     for (let j = 0; j < disps.length; j++) {
                        // console.log( 'disp data: ' + disps[ j ][ 'data' ][ 0 ] );
                        // console.log( 'disp usage: ' + disps[ j ][ 'usage' ][ 0 ][ 'zh' ] );
                        let dataObj = (disps[j]['data'].length > 0) ? disps[j]['data'] : [];
                        let usageObj = (disps[j]['usage'].length > 0) ? disps[j]['usage'] : [];
                        // this.dispObjs.push(dataObj);
                        this.usagesObjs.push(usageObj);
                     }
                  }
                  else {
                     // this.dispObjs.push([]);
                     this.usagesObjs.push([]);
                  }
               }

               // reset active state
               this.active = [];
               for (let i = 0; i < this.consultations.length; i++) {
                  this.active.push((i == 0 && !this.data.isPhy));
               }
               resolve(true);
            }
            else {
               resolve(false);
            }
         });
      });
   }


   upsertTicketActive = () => {
      return new Promise(resolve => {
         let params = {
            'token': this.data.token,
            'tkt_id': this.data.selectedTicket['tkt_id'],
            'from_queue': this.data.selectedTicket['tkt_queue'],
            'from_order': ' ' + this.data.selectedTicket['tkt_order'],
            'to_queue': this.data.selectedTicket['tkt_queue'],
            'isPhy': false
         };
         this.cloudData.upsertTicketActive(params).then(res => {

            // dismiss loading indicator
            resolve(res);
         });
      });
   }

   updateTicketActive = () => {
      return new Promise(resolve => {
         let params = {
            'token': this.data.token,
            'tkt_id': this.data.selectedTicket['tkt_id'],
            'tkt_status': 'active'
            // 'from_queue': this.data.selectedTicket['tkt_queue'],
            // 'from_order': ' ' + this.data.selectedTicket['tkt_order'],
            // 'to_queue': this.data.selectedTicket['tkt_queue'],
            // 'isPhy': false
         };
         this.cloudData.updateTicketActive(params).then(res => {

            // dismiss loading indicator
            resolve(res);
         });
      });
   }


   getDispList = () => {

      return new Promise(resolve => {

         this.cloudData.getDispList().then(res => {

            this.data.symptoms = res['symptoms'];
            this.data.diagnoses = res['diagnose'];
            this.data.dispSingleCats = res['disp_single_cat'];
            this.data.dispSingles = res['disp_single'];
            this.data.dispGrps = res['disp_grp'];
            this.data.dispPills = res['disp_pills'];
            this.data.dispExternals = res['disp_external'];
            this.data.dispInternals = res['disp_internal'];
            this.data.acuSingles = res['acu_single'];
            this.data.acuGrps = res['acu_grp'];
            this.data.usages = res['usage'];
            resolve(res);
         });
      });
   }


   /** ----- UI Callbacks ----- **/

   onBackClicked() {
      //
      //    // if currently under consultation
      //    if ( this.consultationData.editActive == true )
      //    {
      //       let backConfirm = this.alertCtrl.create({
      //          title    : '返回主頁',
      //          subTitle : '已輸入的資料將不會被儲存，確認要返回主頁嗎？',
      //          buttons  : [
      //             {
      //                text     : '確認',
      //                handler  : () => {
      //
      //                   // mark edit currently inactive
      //                   this.consultationData.editActive = false;
      //
      //                   // if navigation stacks more than 3 views
      //                   if ( this.navCtrl.getViews().length > 3 )
      //                   {
      //                      // remove all unnecessary page(s) before pop
      //                      this.navCtrl.remove( 2, this.navCtrl.getViews().length - 3 ).then( res => {
      //
      //                         this.navCtrl.pop();
      //                      });
      //                   }
      //                   else
      //                   {
      //                      this.navCtrl.pop();
      //                   }
      //                }
      //             },
      //             {
      //                text     : '取消',
      //                role     : 'cancel'
      //             }
      //          ],
      //          enableBackdropDismiss: false
      //       });
      //       backConfirm.present();
      //    }
      //    else
      //    {
      //       // if navigation stacks more than 3 views
      if (this.navCtrl.getViews().length > 3) {
         // remove all unnecessary page(s) before pop
         this.navCtrl.remove(2, this.navCtrl.getViews().length - 3).then(res => {
            this.navCtrl.pop();
         });
      }
      else {
         this.navCtrl.pop();
      }
      //    }
      //
   }


   onQueueBtnClicked(inEvent) {

      let tempIdx = this.data.activeTab;
      this.data.activeTab = 0;
      let dxPopover = this.popoverCtrl.create(PopoverQueuePage, {}, { cssClass: 'queue-popover' });
      dxPopover.present({
         ev: inEvent
      });
      dxPopover.onWillDismiss(res => {
         this.data.activeTab = tempIdx;
      });

   }


   onNavBtnClicked(inIdx) {
      // if clicked '進行診症'
      if (inIdx == 2) {
         if (this.data.selectedTicket['tkt_status'] == 'active') {
            this.goToConsultation();
            return;
         }
         // find name to be displayed
         // this.consultationData.clearAll();
         let nameStr = this.data.selectedPatient['pat_lastname_zh'] + this.data.selectedPatient['pat_firstname_zh'];
         if (nameStr.length <= 0 || nameStr == '') nameStr = this.data.selectedPatient['pat_firstname_en'] + ' ' + this.data.selectedPatient['pat_lastname_en'];
         if (nameStr.length <= 0 || nameStr == '') nameStr = '';
         let alert = this.alertCtrl.create({
            title: '開始診症',
            subTitle: '確認要開始為 ' + nameStr + ' 診症嗎？',
            buttons: [
               {
                  text: '返回',
                  role: 'cancel'
               },
               {
                  text: '確認',
                  handler: () => {
                     // show loading indicator and update ticket status
                     let loading = this.modalCtrl.create(LoadingPage, {}, { enableBackdropDismiss: false });
                     loading.present();
                     this.upsertTicketActive().then(res => {

                        // dismiss loading indicator and handle response
                        loading.dismiss();
                        if (res['status'] == true) {
                           // get consultation obj just been active
                           this.consultationData.consultation = res['result']['consultations'];
                           this.data.selectedTicket = res['result']['tickets'];
                           this.goToConsultation();
                        }
                        else {
                           // show error alert
                           let alert = this.alertCtrl.create({
                              title: '上傳失敗',
                              subTitle: '請稍後再嘗試',
                              buttons: [
                                 {
                                    text: '確認',
                                    role: 'cancel'
                                 }
                              ],
                              enableBackdropDismiss: false
                           });
                           alert.present();
                        }
                     });
                  }
               }
            ],
            enableBackdropDismiss: false
         });
         alert.present();
         //continue from pending
      } else if (inIdx == 3) {
         if (this.data.selectedTicket['tkt_status'] == 'active') {
            this.goToConsultation();
            return;
         }
         // find name to be displayed
         // this.consultationData.clearAll();
         let nameStr = this.data.selectedPatient['pat_lastname_zh'] + this.data.selectedPatient['pat_firstname_zh'];
         if (nameStr.length <= 0 || nameStr == '') nameStr = this.data.selectedPatient['pat_firstname_en'] + ' ' + this.data.selectedPatient['pat_lastname_en'];
         if (nameStr.length <= 0 || nameStr == '') nameStr = '';
         let alert = this.alertCtrl.create({
            title: '繼續診症',
            subTitle: '確認要繼續為 ' + nameStr + ' 診症嗎？',
            buttons: [
               {
                  text: '返回',
                  role: 'cancel'
               },
               {
                  text: '確認',
                  handler: () => {
                     // show loading indicator and update ticket status
                     let loading = this.modalCtrl.create(LoadingPage, {}, { enableBackdropDismiss: false });
                     loading.present();
                     this.updateTicketActive().then(res => {
                        // dismiss loading indicator and handle response
                        loading.dismiss();
                        if (res['status'] == true) {
                           // get consultation obj just been active
                           // this.parseConsultationData();
                           this.goToConsultation();
                        }
                        else {
                           // show error alert
                           let alert = this.alertCtrl.create({
                              title: '上傳失敗',
                              subTitle: '請稍後再嘗試',
                              buttons: [
                                 {
                                    text: '確認',
                                    role: 'cancel'
                                 }
                              ],
                              enableBackdropDismiss: false
                           });
                           alert.present();
                        }
                     });
                  }
               }
            ],
            enableBackdropDismiss: false
         });
         alert.present();
      }

   }

   parseConsultationData() {

      let consultation = this.consultationData.consultation
      // let sympObj = {};
      if (Object.keys(consultation).length === 0) {
         return;
      }
      let sympObj = JSON.parse(consultation["con_symptoms"]);
      if (sympObj != null) {
         this.consultationData.chosenSymptoms = JSON.parse(sympObj.data == "" ? '[]' : sympObj.data);
         this.consultationData.chosenSymptomsRemark = JSON.parse(sympObj.remark == "" ? '[]' : sympObj.remark);
      }
      // this.consultationData.chosenSymptoms = sympObj.data;
      // this.consultationData.chosenSymptomsRemark = sympObj.remark;
      if(  JSON.parse(consultation["con_dispensary"]) != null) {
        this.consultationData.chosenDisps = JSON.parse(consultation["con_dispensary"] != null ? consultation["con_dispensary"] : "[]");
      }

      let dxObj = JSON.parse(consultation["con_dx"]);
      // console.log(dxObj)
      if (dxObj != null) {
         this.consultationData.dxIdx = dxObj.idx;
         this.consultationData.dxCustom = (dxObj['idx'] == -2) ? dxObj['val'] : '';
      }
      this.consultationData.consRemark = consultation["con_explain"];

      let noteObj = JSON.parse(consultation["con_notes"]);
      if (noteObj != null) {
         this.consultationData.noteCons = noteObj["cons"];
         this.consultationData.noteDisp = noteObj["disp"];
         this.consultationData.noteAcus = noteObj["acus"];
      }
      if (consultation['con_con_phy'] != null)
         this.consultationData.signCons = consultation['con_con_phy'];

      if (consultation['con_disp_phy'] != null)
         this.consultationData.signDisp = consultation['con_disp_phy'];

      if (consultation['con_acu_phy'] != null)
         this.consultationData.signAcus = consultation['con_acu_phy'];

      this.consultationData.slBegin = consultation["con_sl_begin"];
      this.consultationData.slEnd = consultation["con_sl_end"];
      this.consultationData.slRemark = consultation["con_sl_remark"];
   }

   goToConsultation() {

      // push to Consultation/Dispensary/Verification and remove this page
      this.data.activeTab = 2;
      // this.navCtrl.push( this.data.currentStep == 0 ? ConsultationPage : this.constants.currentStep == 1 ? DispensaryPage : VerificationPage, {}, { animate: false } );

      // this.navCtrl.push(this.data.currentStep == 0 ? ConsultationPage : DispensaryPage, {}, { animate: false });

      this.navCtrl.push(ConsultationPage, {}, { animate: false });

      this.navCtrl.remove( this.navCtrl.getViews().length - 1, 1 );

   }


   onInfoEditClicked() {
      this.navCtrl.push( EditInfoPage );
   }
   //
   //
   onItemClicked(inIdx) {
      this.active[inIdx] = !this.active[inIdx];
   }
   //
   //
   onPrintClicked(inIdx) {
      // Print label
      if (this.constants.isAdmin) {
         let printConfirm = this.alertCtrl.create({
            title: '列印',
            subTitle: '確認要列印配藥標籤嗎？',
            buttons: [
               {
                  text: '中文',
                  handler: () => {

                     let usages = [];
                     for (let i = 0; i < this.dispObjs[inIdx].length; i++) {
                        let currentUsages = [];
                        let usageObj = this.dispObjs[inIdx][i]['usage'];
                        for (let j = 0; j < usageObj.length; j++) {
                           let usageStr = '';
                           if (usageObj[j]['zh'].indexOf('(') > -1 && usageObj[j]['zh'].indexOf(')') > -1) {
                              let startIdx = usageObj[j]['zh'].indexOf('(');
                              let endIdx = usageObj[j]['zh'].indexOf(')') + 2;
                              usageStr = usageObj[j]['zh'].substring(0, startIdx) + usageObj[j]['default'] + " "  + usageObj[j]['zh'].substring(endIdx, usageObj[j]['zh'].length);
                           }
                           else {
                              usageStr = usageObj[j]['zh'];
                           }
                           currentUsages.push(usageStr + " ");
                        }
                        usages.push(currentUsages);
                     }

                     console.log(this.data.selectedPatient)
                     let params = {
                        'lang': 'zh',
                        'pat_name': this.data.selectedPatient['pat_lastname_zh'] + this.data.selectedPatient['pat_firstname_zh'],
                        'date': this.getApiDate(),
                        'admin': usages
                     };
                     console.log(params)
                     this.dispLabel.create(params).then(res => {
                        this.pdfViewer.open(this.dispLabel.pdfObj);
                     });
                  }
               },
               {
                  text: 'English',
                  handler: () => {

                     let usages = [];
                     for (let i = 0; i < this.dispObjs[inIdx].length; i++) {
                        let currentUsages = [];
                        let usageObj = this.dispObjs[inIdx][i]['usage'];
                        for (let j = 0; j < usageObj.length; j++) {
                           let usageStr = '';
                           if (usageObj[j]['en'].indexOf('(') > -1 && usageObj[j]['en'].indexOf(')') > -1) {
                              let startIdx = usageObj[j]['en'].indexOf('(');
                              let endIdx = usageObj[j]['en'].indexOf(')') + 2;
                              usageStr = usageObj[j]['en'].substring(0, startIdx) + usageObj[j]['default'] + " " + usageObj[j]['en'].substring(endIdx, usageObj[j]['en'].length);
                           }
                           else {
                              usageStr = usageObj[j]['en'];
                           }
                           currentUsages.push(usageStr + " ");
                        }
                        usages.push(currentUsages);
                     }

                     let params = {
                        'lang': 'en',
                        'pat_name': this.data.selectedPatient['pat_lastname_en'] + ' ' + this.data.selectedPatient['pat_firstname_en'],
                        'date': this.getApiDate(),
                        'admin': usages
                     };
                     this.dispLabel.create(params).then(res => {

                        this.pdfViewer.open(this.dispLabel.pdfObj);
                     });
                  }
               },
               {
                  text: '取消',
                  role: 'cancel'
               }
            ],
            enableBackdropDismiss: false
         });
         printConfirm.present();
      }
      // Print prescription
      else {
         let printConfirm = this.alertCtrl.create({
            title: '列印',
            subTitle: '確認要列印藥單嗎？',
            buttons: [
               {
                  text: '中文',
                  handler: () => {
                     let pat_name = "";

                     if(!this.constants.selectedPatient['pat_lastname_zh'] && !this.constants.selectedPatient['pat_firstname_zh']){
                        pat_name = this.constants.selectedPatient['pat_lastname_zh'] + this.constants.selectedPatient['pat_firstname_zh'];
                     }else{
                        pat_name = this.constants.selectedPatient['pat_lastname_en'] + ' ' + this.constants.selectedPatient['pat_firstname_en'];
                     }

                     let params = {
                        'lang': 'zh',
                        'pat_name': pat_name,
                        // 'date'         : this.tickets[ inIdx ][ 'tkt_date' ],
                        'date': this.getApiDate(),
                        'phy_name': this.constants.findPdfPhysicianName(this.consultations[inIdx]['phy_id']),
                        'phy_title': this.constants.findPdfPhysicianTitle(this.consultations[inIdx]['phy_id']),
                        'phy_reg_no': this.constants.findPdfPhysicianRegNo(this.consultations[inIdx]['phy_id']),
                        'dispensary': this.dispObjs[inIdx],
                        'address_en': this.constants.pdfAddressEn,
                        'address_zh': this.constants.pdfAddressZh,
                        'tel': this.constants.pdfTel,
                        'fax': this.constants.pdfFax,
                        'url': this.constants.pdfUrl
                     };
                     this.prescription.create(params).then(res => {
                        this.pdfViewer.open(this.prescription.pdfObj);
                     });
                  }
               },
               {
                  text: 'English',
                  handler: () => {
                     let pat_name = "";

                     if(!this.constants.selectedPatient['pat_lastname_en'] && !this.constants.selectedPatient['pat_firstname_en']){
                        pat_name = this.constants.selectedPatient['pat_lastname_en'] + ' ' + this.constants.selectedPatient['pat_firstname_en'];
                     }else{
                        pat_name = this.constants.selectedPatient['pat_lastname_zh'] + this.constants.selectedPatient['pat_firstname_zh'];
                     }

                     let params = {
                        'lang': 'en',
                        'pat_name': pat_name,
                        // 'date'         : this.tickets[ inIdx ][ 'tkt_date' ],
                        'date': this.getApiDate(),
                        'phy_name': this.constants.findPdfPhysicianName(this.consultations[inIdx]['phy_id']),
                        'phy_title': this.constants.findPdfPhysicianTitle(this.consultations[inIdx]['phy_id']),
                        'phy_reg_no': this.constants.findPdfPhysicianRegNo(this.consultations[inIdx]['phy_id']),
                        'dispensary': this.dispObjs[inIdx],
                        'address_en': this.constants.pdfAddressEn,
                        'address_zh': this.constants.pdfAddressZh,
                        'tel': this.constants.pdfTel,
                        'fax': this.constants.pdfFax,
                        'url': this.constants.pdfUrl
                     };
                     this.prescription.create(params).then(res => {

                        this.pdfViewer.open(this.prescription.pdfObj);
                     });
                  }
               },
               {
                  text: '取消',
                  role: 'cancel'
               }
            ],
            enableBackdropDismiss: false
         });
         printConfirm.present();
      }

   }

   refreshSymptoms(inIdx) {
      this.mainSymptoms = [];
      this.mainRemarks = [];
      this.periodSymptoms = [];
      this.periodRemarks = [];
      this.otherSymptoms = [];
      this.otherRemarks = [];
      this.bpSymptoms = [];
      this.bpRemarks = [];

      let chosenSymptom = JSON.parse(this.consultations[inIdx]["con_symptoms"]);
      let chosenSymptomIdx = [];
      try {
        chosenSymptomIdx = JSON.parse(chosenSymptom.data)
      } catch (e) {}
      let chosenSymptomRemarks = [];
      try {
        chosenSymptomRemarks = JSON.parse(chosenSymptom.remark)
      } catch (e) {}

      for (let i = 0; i < chosenSymptomIdx.length; i++) {
         let obj = this.data.getSymptomById(chosenSymptomIdx[i]);
         if (obj['name_zh'] == '主訴') {
            this.mainSymptoms.push(obj);
            this.mainRemarks.push(chosenSymptomRemarks[i]);
         }
         else if (obj['name_zh'] == 'BP') {
            this.bpSymptoms.push(obj);
            // this.bpRemarks.push(this.consObjs['remark'][i]);
            this.bpRemarks.push(chosenSymptomRemarks[i]);
         }
         else if (obj['name_zh'] == 'Lmp' || obj['name_zh'] == 'PMS' || obj['name_zh'] == '帶下') {
            this.periodSymptoms.push(obj);
            this.periodRemarks.push(chosenSymptomRemarks[i]);
         }
         else {
            this.otherSymptoms.push(obj);
            this.otherRemarks.push(chosenSymptomRemarks[i]);
         }
      }
   }

   getDiagnose(con_dx?: string) {
     let obj = {}
     if (con_dx) {
       try {
         obj = JSON.parse(con_dx)
       } catch (e) {
       }
     }

     return obj['val']
   }

   onPrescriptionPrintClicked(inIdx) {
      let printConfirm = this.alertCtrl.create({
         title: '列印',
         subTitle: '確認要列印藥單嗎？',
         buttons: [
            {
               text: '中文',
               handler: () => {

                  let pat_name = "";

                  if(this.data.selectedPatient['pat_lastname_zh'] != "" && this.data.selectedPatient['pat_firstname_zh'] != ""){
                     pat_name = this.data.selectedPatient['pat_lastname_zh'] + this.data.selectedPatient['pat_firstname_zh'];
                  }else{
                     pat_name = this.data.selectedPatient['pat_lastname_en'] + ' ' + this.data.selectedPatient['pat_firstname_en'];
                  }

                  let params = {
                     'lang': 'zh',
                     'pat_name': pat_name,
                     'date' :  this.data.selectedTicket['tkt_date'],
                     // 'date': this.getApiDate(),
                     'phy_name': this.constants.findPdfPhysicianName(this.consultations[inIdx]['phy_id']),
                     'phy_title': this.constants.findPdfPhysicianTitle(this.consultations[inIdx]['phy_id']),
                     'phy_reg_no': this.constants.findPdfPhysicianRegNo(this.consultations[inIdx]['phy_id']),
                     'dispensary': this.dispObjs[inIdx],
                     'address_en': this.constants.pdfAddressEn,
                     'address_zh': this.constants.pdfAddressZh,
                     'tel': this.constants.pdfTel,
                     'fax': this.constants.pdfFax,
                     'url': this.constants.pdfUrl
                  };
                  this.prescription.create(params).then(res => {
                     this.pdfViewer.open(this.prescription.pdfObj);
                  });
               }
            },
            {
               text: 'English',
               handler: () => {
                  let pat_name = "";

                  if(this.data.selectedPatient['pat_lastname_en'] != null && this.data.selectedPatient['pat_firstname_zh'] != null){
                     pat_name = this.data.selectedPatient['pat_lastname_en'] + ' ' + this.data.selectedPatient['pat_firstname_en'];
                  }else{
                     pat_name = this.data.selectedPatient['pat_lastname_zh'] + this.data.selectedPatient['pat_firstname_zh'];
                  }

                  let params = {
                     'lang': 'en',
                     'pat_name': pat_name,
                     'date' :  this.data.selectedTicket['tkt_date'],
                     'phy_name': this.constants.findPdfPhysicianName(this.consultations[inIdx]['phy_id']),
                     'phy_title': this.constants.findPdfPhysicianTitle(this.consultations[inIdx]['phy_id']),
                     'phy_reg_no': this.constants.findPdfPhysicianRegNo(this.consultations[inIdx]['phy_id']),
                     'dispensary': this.dispObjs[inIdx],
                     'address_en': this.constants.pdfAddressEn,
                     'address_zh': this.constants.pdfAddressZh,
                     'tel': this.constants.pdfTel,
                     'fax': this.constants.pdfFax,
                     'url': this.constants.pdfUrl
                  };
                  this.prescription.create(params).then(res => {

                     this.pdfViewer.open(this.prescription.pdfObj);
                  });
               }
            },
            {
               text: '取消',
               role: 'cancel'
            }
         ],
         enableBackdropDismiss: false
      });
      printConfirm.present();
   }


   onHistoryPrintClicked(inIdx) {
      this.mainSymptoms = [];
      this.refreshSymptoms(inIdx);
      let printConfirm = this.alertCtrl.create({
         title: '列印',
         subTitle: '確認要列印病歷嗎？',
         buttons: [
            {
               text: '取消',
               role: 'cancel'
            },
            {
               text: '確認',
               handler: () => {
                  console.log(this.consultations[inIdx])
                  // let dxStr = (this.consultations[inIdx]['con_dx'] != null) ? this.consultations[inIdx]['con_dx']['val'] : '';
                  let dxStr = (this.consultations[inIdx]['con_dx'] != null) ? this.getDiagnose(this.consultations[inIdx]['con_dx']) : '';
                  let params = {
                     'createdate': this.consultations[inIdx]['con_createtime'],
                     'name': (this.data.selectedPatient['pat_lastname_zh'].length > 0 || this.data.selectedPatient['pat_firstname_zh'].length > 0) ?
                        this.data.selectedPatient['pat_lastname_zh'] + this.data.selectedPatient['pat_firstname_zh'] : this.data.selectedPatient['pat_lastname_en'] + ' ' + this.data.selectedPatient['pat_firstname_en'] ,
                     'diagnose': dxStr,
                     'bpRemarks': this.bpRemarks,
                     'con_phy': (this.consultations[inIdx]['con_con_phy'] != null) ? this.constants.findPhysicianName(this.consultations[inIdx]['con_con_phy']['phy_id']) : '',
                     'disp_phy': (this.consultations[inIdx]['con_disp_phy'] != null) ? this.constants.findPhysicianName(this.consultations[inIdx]['con_disp_phy']['phy_id']) : '',
                     'acu_phy': (this.consultations[inIdx]['con_acu_phy'] != null) ? this.constants.findPhysicianName(this.consultations[inIdx]['con_acu_phy']['phy_id']) : '',
                     'dispensings': '',
                     'notes_cons': JSON.parse(this.consultations[inIdx]['con_notes'])['cons'],
                     'notes_disp': JSON.parse(this.consultations[inIdx]['con_notes'])['disp'],
                     'notes_acus': JSON.parse(this.consultations[inIdx]['con_notes'])['acus'],
                     'main_remarks': this.mainRemarks[0],
                     'p_symptoms': this.periodSymptoms,
                     'p_remarks': this.periodRemarks,
                     'symptoms': this.otherSymptoms,
                     'remarks': this.otherRemarks,
                     'explain': this.consultations[inIdx]['con_explain'],
                     'dispensary': this.dispObjs[inIdx],
                  };
                  this.consHistory.create(params).then(res => {

                     this.pdfViewer.open(this.consHistory.pdfObj);
                  });
               }
            }
         ],
         enableBackdropDismiss: false
      });
      printConfirm.present();

   }
   //
   //
   // onItemAddClicked( inIdx )
   // {
   //
   //    // prompt for confirmation
   //    let editConfirm = this.alertCtrl.create({
   //       title    : '複製診症藥單紀錄',
   //       subTitle : '確認要複製診症藥單，並進行診症嗎？',
   //       buttons  : [
   //          {
   //             text     : '確認',
   //             handler  : () => {
   //
   //                this.consultationData.clearAll();
   //                this.onNavBtnClicked( 1 );
   //                this.consultationData.editMode = true;
   //                this.consultationParser.convertSymptoms( this.consultations[ inIdx ] );
   //                this.consultationParser.convertDispensaries( this.dispObjs[ inIdx ] );
   //                this.consultationParser.convertDiagnose( this.consultations[ inIdx ][ 'con_dx' ] );
   //                this.consultationParser.convertNotes( this.consultations[ inIdx ][ 'con_notes' ] );
   //
   //             }
   //          },
   //          {
   //             text     : '取消',
   //             role     : 'cancel'
   //          }
   //       ],
   //       enableBackdropDismiss: false
   //    });
   //    editConfirm.present();
   //
   // }
   //
   onStartDispClicked(mode) {      // return;
      let param = {
         'token': this.data.token,
         'tkt_id': this.data.selectedTicket['tkt_id'],
         'is_disping': mode
      }
      // prompt for confirmation
      let onStartDispConfirm = this.alertCtrl.create({
         title: mode == 1 ? '開始配藥' : '完成配藥',
         subTitle: mode == 1 ? '是否確認開始配藥?' : '是否確認完成配藥?',
         buttons: [
            {
               text: '取消',
               role: 'cancel'
            },
            {
               text: '確認',
               handler: () => {
                  let loading = this.modalCtrl.create(LoadingPage, {}, { enableBackdropDismiss: false });
                  loading.present();
                  // clear all selection
                  this.cloudData.dispButtonClicked(param)
                     .then(res => {
                        if (res['status'])
                           this.data.selectedTicket = res['result']['ticket'];
                        loading.dismiss();
                     })
                     .catch(err => {
                        loading.dismiss();
                     });
               }
            }
         ],
         enableBackdropDismiss: false
      });
      onStartDispConfirm.present();
   }
   //
   // onItemEditClicked( inIdx )
   // {
   //
   //    // only allow 'DONE' or 'DISPENSING' ticket for admin accounts
   //    if ( this.constants.isAdmin &&
   //       !( this.consultations[ inIdx ][ 'tkt_id' ][ 'tkt_status' ] == 'done' || this.consultations[ inIdx ][ 'tkt_id' ][ 'tkt_status' ] == 'dispensing' ) )
   //    {
   //       // show alert for permission declined
   //       let error = this.alertCtrl.create({
   //          title    : '存取拒絕',
   //          subTitle : '您的帳號沒有此權限',
   //          buttons  : [
   //             {
   //                text     : '確認',
   //                role     : 'cancel'
   //             }
   //          ],
   //          enableBackdropDismiss: false
   //       });
   //       error.present();
   //       return;
   //    }
   //
   //    // prompt for confirmation
   //    let editConfirm = this.alertCtrl.create({
   //       title    : ( this.consultationData.editActive ) ? '診症進行中' : '編輯診症藥單紀錄',
   //       subTitle : ( this.consultationData.editActive ) ? '確認要放棄進行中的診症嗎？' : '確認要繼續嗎？',
   //       buttons  : [
   //          {
   //             text     : '確認',
   //             handler  : () => {
   //
   //                this.consultationData.clearAll();
   //                this.consultationData.editMode = true;
   //                this.consultationParser.convertSymptoms( this.consultations[ inIdx ] );
   //                this.consultationParser.convertDispensaries( this.dispObjs[ inIdx ] );
   //                this.consultationParser.convertDiagnose( this.consultations[ inIdx ][ 'con_dx' ] );
   //                this.consultationParser.convertNotes( this.consultations[ inIdx ][ 'con_notes' ] );
   //                this.navCtrl.push( ConsultationPage );
   //                this.constants.isEdit = true;
   //             }
   //          },
   //          {
   //             text     : '取消',
   //             role     : 'cancel'
   //          }
   //       ],
   //       enableBackdropDismiss: false
   //    });
   //    editConfirm.present();
   //
   // }
   //
   //
   showUsageItemPrefix(inObj) {
      let zhStr = inObj['zh'];
      let zhStart = zhStr.indexOf('(');
      let zhEnd = zhStr.indexOf(')');
      if (zhStart > -1 && zhEnd > -1) zhStr = zhStr.substring(0, zhStart);
      return (zhStr);
   }


   showUsageItemDefault(inObj) {
      let zhStr = inObj['zh'];
      let zhStart = zhStr.indexOf('(');
      let zhEnd = zhStr.indexOf(')');
      return (zhStart > -1 && zhEnd > -1) ? inObj['default'] : '';
   }


   showUsageItemSuffix(inObj) {
      let zhStr = inObj['zh'];
      let zhStart = zhStr.indexOf('(');
      let zhEnd = zhStr.indexOf(')');
      if (zhStart > -1 && zhEnd > -1 && zhEnd + 2 < zhStr.length) {
         return zhStr.substring(zhEnd + 2, zhStr.length);
      }
      else {
         return '';
      }
   }

   getApiDate() {
      let dateStr = '';
      let monthStr = '' + (new Date().getMonth() + 1);
      if (monthStr.length == 1) monthStr = '0' + monthStr;
      let dayStr = '' + new Date().getDate();
      if (dayStr.length == 1) dayStr = '0' + dayStr;
      dateStr = new Date().getFullYear() + '-' + monthStr + '-' + dayStr;
      console.log('date: ' + dateStr);
      return dateStr;
   }

   getDispGrpById(inId) {
      return this.data.getDispGrpById(inId);
   }

   getDispPillById(inId) {
      return this.data.getDispPillById(inId);
   }

   getAcuGrpById(inId) {
      return this.data.getAcuGrpById(inId);
   }

   getDispSingleById(inId) {
      return this.data.getDispSingleById(inId);
   }
   //

   //
   //
   //
   //
   // onConsHistoryChosen( inIdx ){
   //
   //
   //       let dxStr = ( this.consultations[ inIdx ][ 'con_dx' ] != null ) ? this.consultations[ inIdx ][ 'con_dx' ][ 'val' ] : '';
   //       let params = {
   //          'name'         : "陳大文",
   //          'diagnose'     : dxStr,
   //          'con_phy'      : "醫師一",
   //          'disp_phy'     : "醫師一",
   //          'acu_phy'      : "醫師一",
   //          'dispensings'  : '',
   //          'notes_cons'   : this.consultations[ inIdx ][ 'con_notes' ][ 'cons' ],
   //          'notes_disp'   : this.consultations[ inIdx ][ 'con_notes' ][ 'disp' ],
   //          'notes_acus'   : this.consultations[ inIdx ][ 'con_notes' ][ 'acus' ],
   //          'main_remarks' : this.mainRemarks[ 0 ],
   //          'p_symptoms'   : this.periodSymptoms,
   //          'p_remarks'    : this.periodRemarks,
   //          'symptoms'     : this.otherSymptoms,
   //          'remarks'      : this.otherRemarks,
   //          'explain'      : this.consultations[ inIdx ][ 'con_explain' ],
   //          'dispensary'   : this.dispObjs[ inIdx ]
   //       };
   //       this.consHistory.create( params ).then( res => {
   //
   //          this.pdfViewer.open( this.consHistory.pdfObj );
   //       });
   //
   //
   // }
   //
   onMedCertChosen(inIdx) {

      let ticket = this.data.selectedTicket;
      let checkInTime;
      if(ticket["tkt_checkin"] != null){
         checkInTime = ticket["tkt_checkin"]["checkin_time"];
      }else{
         checkInTime = ticket["tkt_createtime"];
      }

      let displayCheckInTime = this.helper.fullTimeConvert( checkInTime );
      let endTime = this.helper.fullTimeConvert( this.consultations[inIdx]["con_endtime"], true );

      let dxStr = (this.consultations[inIdx]['con_dx'] != null) ? this.getDiagnose(this.consultations[inIdx]['con_dx']) : '';
      console.log(this.consultations[inIdx]);
      let params = {
         'pat_gender': this.data.selectedPatient['pat_gender'],
         'pat_name': this.data.selectedPatient['pat_lastname_en'] + ' ' + this.data.selectedPatient['pat_firstname_en'],
         'diagnose': dxStr,
         'cons_date': this.getApiDate(),
         // 'cons_start': this.consultations[inIdx]["con_createtime"].split(" ")[1],
         'cons_start': displayCheckInTime,
         // 'cons_end': this.consultations[inIdx]["con_endtime"].split(" ")[1],
         'cons_end': endTime,
         'phy_name': this.constants.findPdfPhysicianName(this.consultations[inIdx]['phy_id']),
         'phy_title': this.constants.findPdfPhysicianTitle(this.consultations[inIdx]['phy_id']),
         'phy_reg_no': this.constants.findPdfPhysicianRegNo(this.consultations[inIdx]['phy_id']),
         'address_en': this.constants.pdfAddressEn,
         'address_zh': this.constants.pdfAddressZh,
         'tel': this.constants.pdfTel,
         'fax': this.constants.pdfFax,
         'url': this.constants.pdfUrl
      };
      this.medicalCert.create(params).then(res => {
         this.pdfViewer.open(this.medicalCert.pdfObj);
      });
   }


   onSickLeaveChosen(inIdx) {

      let dxStr = (this.consultations[inIdx]['con_dx'] != null) ? this.getDiagnose(this.consultations[inIdx]['con_dx']) : '';
      console.log(this.consultations[inIdx])
      let params = {
         'createdate': this.consultations[inIdx]['con_createtime'],
         'pat_gender': this.data.selectedPatient['pat_gender'],
         'pat_name': this.data.selectedPatient['pat_lastname_zh'] + this.data.selectedPatient['pat_firstname_zh'],
         'pat_dob': this.data.selectedPatient['pat_dob'],
         'diagnose': dxStr,
         'sl_start': this.consultations[inIdx]['con_sl_begin'],
         'sl_end': this.consultations[inIdx]['con_sl_end'],
         'sl_remark': this.consultations[inIdx]['con_sl_remark'],
         'remark': '',
         'phy_name': this.constants.findPdfPhysicianName(this.consultations[inIdx]['phy_id']),
         'phy_title': this.constants.findPdfPhysicianTitle(this.consultations[inIdx]['phy_id']),
         'phy_reg_no': this.constants.findPdfPhysicianRegNo(this.consultations[inIdx]['phy_id']),
         'address_en': this.constants.pdfAddressEn,
         'address_zh': this.constants.pdfAddressZh,
         'tel': this.constants.pdfTel,
         'fax': this.constants.pdfFax,
         'url': this.constants.pdfUrl
      };
      this.sickLeave.create(params).then(res => {

         this.pdfViewer.open(this.sickLeave.pdfObj);
      });
   }

}



// WEBPACK FOOTER //
// ./src/pages/history/history.ts